function isSharedSliceModel(input) {
  return typeof input === "object" && input !== null && "type" in input && input.type === "SharedSlice" && "id" in input && typeof input.id === "string";
}
export {
  isSharedSliceModel
};
//# sourceMappingURL=isSharedSliceModel.js.map
